import { UseFormTools } from "@wisr/common";
import React from "react";
import { Application } from "../../../application/application";

import licenceACT from "../../../assets/images/licence-ACT.svg";
import licenceNSW from "../../../assets/images/licence-NSW.svg";
import licenceNTback from "../../../assets/images/licence-NT-back.svg";
import licenceNTfront from "../../../assets/images/licence-NT-front.svg";
import licenceQLDback from "../../../assets/images/licence-QLD-back.svg";
import licenceQLDfront from "../../../assets/images/licence-QLD-front.svg";
import licenceSA from "../../../assets/images/licence-SA.svg";
import licenceTAS from "../../../assets/images/licence-TAS.svg";
import licenceVICback from "../../../assets/images/licence-VIC-back.svg";
import licenceWA from "../../../assets/images/licence-WA.svg";
import { StateValues } from "../../../application/multi-page-application-form/form-pages/id-documents/id-documents.consts";
import { QuoteForm } from "../../../quote/quote-form";

export const QLD_CARD_NUMBER: React.ReactElement = (
  <>
    <p>
      Your card number can be found on the front and back of your licence at the
      bottom of the card.
    </p>
    <div className="card-display">
      <div>
        <img src={licenceQLDfront} />
        <div className="subtitle">Front of licence</div>
      </div>
    </div>
    <div className="card-display">
      <div>
        <img src={licenceQLDback} />
        <div className="subtitle">Back of licence</div>
      </div>
    </div>
  </>
);

export const NSW_CARD_NUMBER: React.ReactElement = (
  <>
    <p>
      If you&apos;re using the Service NSW app, open your digital licence and
      scroll down to find your card number.
    </p>
    <p>On your physical card, it&apos;s in the top right-hand corner</p>
    <div className="card-display">
      <div>
        <img src={licenceNSW} />
        <div className="subtitle">Front of licence</div>
      </div>
    </div>
  </>
);

export const ACT_CARD_NUMBER: React.ReactElement = (
  <>
    <p>
      Your card number can be found on the front of your licence to the left of
      your photo.
    </p>
    <div className="card-display">
      <div>
        <img src={licenceACT} />
        <div className="subtitle">Front of licence</div>
      </div>
    </div>
  </>
);

export const NT_CARD_NUMBER: React.ReactElement = (
  <>
    <p>
      Your card number can be found on the back of your licence at the bottom of
      the card.
    </p>
    <div className="card-display">
      <div>
        <img src={licenceNTfront} />
        <div className="subtitle">
          Back of NT licence issued <strong>before</strong> 1 Nov 2020
        </div>
      </div>
    </div>
    <div className="card-display">
      <div>
        <img src={licenceNTback} />
        <div className="subtitle">
          Back of NT licence issued <strong>after</strong> 1 Nov 2020
        </div>
      </div>
    </div>
  </>
);

export const TAS_CARD_NUMBER: React.ReactElement = (
  <>
    <p>
      Your card number can be found on the back of your licence in the top
      right-hand corner.
    </p>
    <div className="card-display">
      <div>
        <img src={licenceTAS} />
        <div className="subtitle">Back of licence</div>
      </div>
    </div>
  </>
);

export const WA_CARD_NUMBER: React.ReactElement = (
  <>
    <p>
      Your card number can be found on the back of your licence on the
      right-hand side.
    </p>
    <div className="card-display">
      <div>
        <img src={licenceWA} />
        <div className="subtitle">Back of licence</div>
      </div>
    </div>
  </>
);

export const SA_CARD_NUMBER: React.ReactElement = (
  <>
    <p>
      If you&apos;re viewing your digital licence on the mySAGOV app,
      you&apos;ll find your card number in the details tab.
    </p>
    <p>
      On the physical card, it&apos;s on the back of your licence in the top
      right-hand corner.
    </p>
    <div className="card-display">
      <div>
        <img src={licenceSA} />
        <div className="subtitle">Back of licence</div>
      </div>
    </div>
  </>
);

export const VIC_CARD_NUMBER: React.ReactElement = (
  <>
    <p>
      Your card number can be found on the back of your licence on the
      right-hand side.
    </p>
    <div className="card-display">
      <div>
        <img src={licenceVICback} />
        <div className="subtitle">Back of licence</div>
      </div>
    </div>
  </>
);

export const stateCardNumberInfographic = ({
  showCardNumberInfo,
  formData,
}: {
  showCardNumberInfo: boolean;
  formData:
    | UseFormTools<Application>["formData"]
    | UseFormTools<QuoteForm>["formData"];
}) => {
  if (!showCardNumberInfo) return null;

  switch (formData.driversLicenceState) {
    case StateValues.QLD:
      return QLD_CARD_NUMBER;
    case StateValues.NSW:
      return NSW_CARD_NUMBER;
    case StateValues.ACT:
      return ACT_CARD_NUMBER;
    case StateValues.NT:
      return NT_CARD_NUMBER;
    case StateValues.TAS:
      return TAS_CARD_NUMBER;
    case StateValues.WA:
      return WA_CARD_NUMBER;
    case StateValues.SA:
      return SA_CARD_NUMBER;
    case StateValues.VIC:
      return VIC_CARD_NUMBER;
  }
};
